import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArea(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.25 7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V7.75H13a.75.75 0 0 1-.75-.75M11 17.75a.75.75 0 0 0 0-1.5H7.75V13a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 5.5A2.75 2.75 0 0 1 5.5 2.75h13a2.75 2.75 0 0 1 2.75 2.75v13a2.75 2.75 0 0 1-2.75 2.75h-13a2.75 2.75 0 0 1-2.75-2.75zM5.5 4.25c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h13c.69 0 1.25-.56 1.25-1.25v-13c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcArea = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArea));

export { IcArea as I };
